<script module>
	export const Medications = [
	{
			name: "Mounjaro\u00AE",
			id: "1",
			doses: [
				"2.5 mg",
				"5.0 mg",
				"7.5 mg",
				"10.0 mg",
				"12.5 mg",
				"15.0 mg",
			],
		},
		{
			name: "Ozempic\u00AE",
			id: "2",
			doses: [
				"0.25 mg",
				"0.50 mg",
				"1.00 mg",
				"1.50 mg",
				"2.00 mg",
				"4.00 mg",
				"9.00 mg",
			],
		},
		{
			name: "Rybelsus\u00AE",
			id: "3",
			doses: [
				"3 mg",
				"7 mg",
				"14 mg"
			],
		},
		{
			name: "Trulicity\u00AE",
			id: "4",
			doses: [
				"0.75 mg",
				"1.00 mg",
				"3.00 mg",
				"4.50 mg",
			],
		},
		{
			name: "Other",
			id: "-1",
			doses: [
				"0.25 mg",
				"0.50 mg",
				"0.75 mg",
				"1.00 mg",
				"2.00 mg",
				"2.50 mg",
				"3.00 mg",
				"4.50 mg",
				"5.00 mg",
				"7.00 mg",
				"7.50 mg",
				"10.00 mg",
				"12.50 mg",
				"14.00 mg",
				"15.00 mg",
			],
		},];
		
		export const PreviousMedications = [
			{ name: "Bydureon\u00AE", checked: false },
			{ name: "Mounjaro\u00AE", checked: false },
			{ name: "Ozempic\u00AE", checked: false },
			{ name: "Rybelsus\u00AE", checked: false },
			{ name: "Trulicity\u00AE", checked: false },
			{ name: "None", checked: false },
			{ name: "Other", checked: false },
		];
</script>